import { useEffect, useState } from "react";
import styled from "styled-components";
import Countdown from "react-countdown";
import { Button, CircularProgress, Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import * as anchor from "@project-serum/anchor";

import { LAMPORTS_PER_SOL } from "@solana/web3.js";

import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";

import {
  CandyMachine,
  awaitTransactionSignatureConfirmation,
  getCandyMachineState,
  mintOneToken,
  shortenAddress,
} from "./candy-machine";

const ConnectButton = styled(WalletDialogButton)``;

const CounterText = styled.span``; // add your styles here

const MintContainer = styled.div`font-size:45px`; // add your styles here

const MintButton = styled(Button)`padding:10%;`; // add your styles here

export interface HomeProps {
  candyMachineId: anchor.web3.PublicKey;
  config: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  treasury: anchor.web3.PublicKey;
  txTimeout: number;
}

const Home = (props: HomeProps) => {
  const [balance, setBalance] = useState<number>();
  const [isActive, setIsActive] = useState(false); // true when countdown completes
  const [isSoldOut, setIsSoldOut] = useState(false); // true when items remaining is zero
  const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT
  const [counter, setCounter] = useState<any>({});
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });

  const [startDate, setStartDate] = useState(new Date(props.startDate));

  const wallet = useAnchorWallet();
  const [candyMachine, setCandyMachine] = useState<CandyMachine>();

  const onMint = async () => {
    try {
      setIsMinting(true);
      if (wallet && candyMachine?.program) {
        const mintTxId = await mintOneToken(
          candyMachine,
          props.config,
          wallet.publicKey,
          props.treasury
        );

        const status = await awaitTransactionSignatureConfirmation(
          mintTxId,
          props.txTimeout,
          props.connection,
          "singleGossip",
          false
        );

        if (!status?.err) {
          setAlertState({
            open: true,
            message: "Congratulations! Mint succeeded!",
            severity: "success",
          });
        } else {
          setAlertState({
            open: true,
            message: "Mint failed! Please try again!",
            severity: "error",
          });
        }
      }
    } catch (error: any) {
      // TODO: blech:
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (error.message.indexOf("0x138")) {
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          setIsSoldOut(true);
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
      setIsMinting(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
    })();
  }, [wallet, props.connection]);

  useEffect(() => {
    (async () => {
      if (!wallet) return;

      const { candyMachine, goLiveDate, itemsRemaining, itemsAvailable,} =
        await getCandyMachineState(
          wallet as anchor.Wallet,
          props.candyMachineId,
          props.connection
        );

      setIsSoldOut(itemsRemaining === 0);
      setStartDate(goLiveDate);
      setCandyMachine(candyMachine);
      setCounter({
        itemsRemaining,
        itemsAvailable
      });
      
    })();
  }, [wallet, props.candyMachineId, props.connection]);

  return (
    <main>
      <div className="mainTitleAX" style={{ background: `url(https://i.imgur.com/A57VqDR.jpg) center center no-repeat #000000` }} >
        <h1 className="h3TitleAX">AXGANS</h1>
        <h3 className="h4TitleAX">AbstraX GAN Paintings are artworks generated by Playform trained on combination of abstract patterns and drawings by Solorigins.</h3>

        <h3 className="h4TitleAX">Minting will be handled with 🖤 Candy Machine created by Metaplex 🖤 - no manual refunds needed, and SOL will only be deducted if your mint is successful.</h3>
        <h3 className="h4TitleAX instructAX">🖤 ONLY 1,500 unique AXGANS will be minted forever.</h3>
        <h3 className="h4TitleAX instructAX">🖤 Mint Price is 2 SOL per AXGANS</h3>
        <h3 className="h4TitleAX instructAX">🖤 No Bonding Curve, all AXGANS are priced the same.</h3>
      </div>

      
      <div className='mintCaseIntroAX'>
        {wallet && (
          <p className='centralizedAXGAN'>Address: {shortenAddress(wallet.publicKey.toBase58() || "")}</p>
        )}

        {wallet && (
          <p className='centralizedAXGAN'>Balance: {(balance || 0).toLocaleString()} SOL</p>
        )}
        {!!counter && (
        
          <p className='centralizedAXGAN'>Items available: {counter.itemsRemaining} / {counter.itemsAvailable}</p>
      )}

        <MintContainer>
          {!wallet ? (<ConnectButton>Connect Wallet</ConnectButton>) : (
            <div className="mainTitleAXDiv">
              <MintButton disabled={isSoldOut || isMinting || !isActive} onClick={onMint} variant="contained">
                {isSoldOut ? ("SOLD OUT") : isActive ? (isMinting ?
                  (<CircularProgress />) : ("MINT FOR 2 SOL")
                ) : (<Countdown
                  date={startDate}
                  onMount={({ completed }) => completed && setIsActive(true)}
                  onComplete={() => setIsActive(true)}
                  renderer={renderCounter}
                />
                )}
              </MintButton>
            </div>
          )}
        </MintContainer>
        <h3 className="h4TitleAX centerizAX">Please connect your digital wallet to mint.</h3>

      </div>

      <div className="mintCaseIntroAX warningAX">
        <p className="howtoSection">🖤 Warning! You will be able to purchase 1 AXGANS per transaction until they're gone. If you want to mint multiple AXGANS, please repeat the operation as many times as necessary. Please send only one payment at a time.
        </p>
        <p className="howtoSection">🖤 Once your payment is confirmed, AXGANS minting will be automated. You will receive your token directly to your digital wallet within 5 minutes. You will be able view your NFTs on "Collectibles" section of your Digital Wallet. 
        </p>
        <p className="howtoSection"><a target='_blank' href='https://axgans.solorigins.io/'>🖤 Take me Back to AXGANS Website.</a>
        </p>
      </div>
      <div style={{ background: `url(https://i.imgur.com/3syrfCK.jpg) center center no-repeat #000000` }} className="bannerBottom"></div>


      <footer>
        <div className="container mintCaseIntroAX">
            <div className="row">
                <div className="footer-mensItem">
                    <a href="https://twitter.com/SolOrigins" target="_blank"><svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" className="twtr-color-fill--blue-dark"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.04128 17.7861C4.53883 17.7861 2.21078 17.0602 0.25 15.8165C0.596807 15.857 0.949401 15.8773 1.30683 15.8773C3.38266 15.8773 5.29282 15.1764 6.80944 14.0003C4.87 13.9646 3.23461 12.6968 2.67056 10.9547C2.94041 11.0059 3.21803 11.0338 3.50342 11.0338C3.90767 11.0338 4.2993 10.9798 4.67133 10.8796C2.64431 10.4775 1.11689 8.70468 1.11689 6.5808C1.11689 6.56156 1.11689 6.54327 1.11792 6.52489C1.71505 6.85368 2.39787 7.05133 3.12448 7.07347C1.93514 6.28783 1.15299 4.94488 1.15299 3.42361C1.15299 2.62053 1.37213 1.86754 1.75297 1.21971C3.93781 3.87277 7.20298 5.61776 10.885 5.80097C10.8091 5.47987 10.7701 5.14535 10.7701 4.80118C10.7701 2.38039 12.7543 0.416626 15.2012 0.416626C16.4753 0.416626 17.6267 0.949734 18.4351 1.80197C19.4444 1.60535 20.392 1.23997 21.2484 0.737722C20.9172 1.76154 20.2148 2.62053 19.3002 3.1633C20.1963 3.0572 21.0506 2.82194 21.8444 2.47297C21.2512 3.35223 20.4993 4.12445 19.6342 4.7433C19.643 4.93129 19.6469 5.12031 19.6469 5.31018C19.6469 11.1042 15.1905 17.7861 7.04128 17.7861Z" fill="#1DA1F2"></path></svg> Follow @SolOrigins</a>
                </div>
                <div className="footer-mensItem">© 2021 AXGANS by SolOrigins ❤️</div>
            </div>
        </div>
    </footer>

      <Snackbar
        open={alertState.open}
        autoHideDuration={6000}
        onClose={() => setAlertState({ ...alertState, open: false })}
      >
        <Alert
          onClose={() => setAlertState({ ...alertState, open: false })}
          severity={alertState.severity}
        >
          {alertState.message}
        </Alert>
      </Snackbar>
    </main>
  );
};

interface AlertState {
  open: boolean;
  message: string;
  severity: "success" | "info" | "warning" | "error" | undefined;
}

const renderCounter = ({ days, hours, minutes, seconds, completed }: any) => {
  return (
    <CounterText>
      {hours} hours, {minutes} minutes, {seconds} seconds
    </CounterText>
  );
};

export default Home;
